/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const ChefImageModal = ({ data, show, handleUpdateChef, handleDismiss, loading }) => {
  const [chefImage, setChefImage] = useState(
    data.chefImage ? data.chefImage : ""
  );
  const [dragOver, setDragOver] = useState(false);
  const [triedImageUpload, setTriedImageUpload] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setTriedImageUpload(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      setChefImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (!file) return;

    setTriedImageUpload(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      setChefImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleClickUpload = () => {
    document.getElementById("fileInput").click();
  };

  const handleClose = () => {
    handleDismiss();
  };

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Add Chef Image Picture</Modal.Title>
        <span onClick={handleClose} style={{ cursor: "pointer" }}>&#10006;</span>
      </Modal.Header>
      <Modal.Body>
        <div className="custom-file-upload">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="form-control"
            id="fileInput"
          />
          <div
            className={`dropzone ${dragOver ? "dragover" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={handleClickUpload}
          >
            {chefImage ? (
              <img
                src={chefImage}
                alt="Profile"
                className="mt-2 img-fluid"
                style={{ maxHeight: "200px" }}
              />
            ) : (
              <p>
                Drag & Drop or Click to Upload
                <br />
              </p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {triedImageUpload && (
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleUpdateChef(chefImage);
              }}
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Close
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ChefImageModal;
